import 'react-phone-input-2/lib/style.css';
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { FastField, getIn } from 'formik';
import MaskedInput from 'react-text-mask';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import PhoneInput from 'react-phone-input-2';
import { Input as SemanticInput } from 'semantic-ui-react';
import { InputDropdown } from '../InputDropdown';
import RedCross from '../../../Login/red-cross.svg';
import BlueTick from '../../../Login/blue-tick.svg';

const PhoneNumberInput = ({
  name,
  label,
  type,
  mask,
  containerClassName,
  inputContainerClassName,
  labelClassName,
  inputClassName,
  invalid,
  showError,
  fluid,
  ddi,
  placeholder,
  checkMask,
  oldStyle,
  hasInput,
  ...rest
}) => (
  <FastField
    type={type}
    name={name}
    render={({ field, form }) => {
      const error = getIn(form.errors, field.name);
      const touched = getIn(form.touched, field.name);
      const showFieldError = showError && touched && !!error;
      return oldStyle ? (
        <div
          className={classNames(
            oldStyle && 'col-12 col-md mb-3',
            containerClassName,
          )}
        >
          {!isEmpty(label) && (
            <label
              className={classNames(
                labelClassName,
                showFieldError && 'text-danger',
              )}
            >
              {label}
            </label>
          )}
          <div
            className={classNames(
              'input__container w-100',
              inputContainerClassName,
            )}
          >
            <SemanticInput error={showFieldError} fluid={fluid}>
              <InputDropdown
                className="input__left-dropdown"
                name={name}
                ddi={ddi}
              />
              <MaskedInput
                {...field}
                {...rest}
                placeholder={placeholder}
                className={classNames(
                  'input__with-dropdown form-control',
                  inputClassName,
                )}
                mask={checkMask(mask, type)}
                guide={false}
                type={type}
              />
            </SemanticInput>
            {invalid !== undefined &&
              (invalid ? (
                <img
                  alt="input invalid"
                  src={RedCross}
                  className="input__icon"
                />
              ) : (
                <img alt="input valid" src={BlueTick} className="input__icon" />
              ))}
            {showFieldError && (
              <div className="invalid-feedback d-block">{error}</div>
            )}
          </div>
        </div>
      ) : (
        <label
          className={`input ${hasInput && !oldStyle ? 'has-input' : ''} ${
            type === 'textArea' ? 'textarea' : ''
          }`}
        >
          <span className="input-label text-gray-light">{`${label} (optional)`}</span>
          <PhoneInput
            inputProps={{
              name: 'phoneNumber',
              className: `input-field form-control ${rest.extraInputClassName}`,
            }}
            country="us"
            value={
              rest.formInfo
                ? rest.formInfo.phoneNumber || ''
                : rest.phone_number
            }
            onChange={(phone, country) => {
              if (rest.extraInputClassName) {
                rest.onChange({ name: 'phone_number', value: phone }, form);
                rest.onChange(
                  { name: 'dialCode', value: country.dialCode },
                  form,
                );
              } else {
                rest.onChange({
                  target: { name: 'phoneNumber', value: phone },
                });
                rest.onChange({
                  target: { name: 'dialCode', value: `+${country.dialCode}` },
                });
                rest.onChange({
                  target: { name: 'country', value: country.name },
                });
              }
            }}
          />
        </label>
      );
    }}
  />
);

PhoneNumberInput.defaultProps = {
  oldStyle: true,
};

PhoneNumberInput.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  mask: PropTypes.oneOfType([PropTypes.array, PropTypes.bool]),
  containerClassName: PropTypes.string,
  inputContainerClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  inputClassName: PropTypes.string,
  placeholder: PropTypes.string,
  invalid: PropTypes.bool,
  showError: PropTypes.bool,
  fluid: PropTypes.bool,
  ddi: PropTypes.array,
  rest: PropTypes.object,
  checkMask: PropTypes.func,
  oldStyle: PropTypes.bool,
};

export default memo(PhoneNumberInput);



// WEBPACK FOOTER //
// ./src/components/Form/Input/PhoneNumberInput/index.js